import { awsApiInstance } from '../api/aws-api';
import { apiRetry } from '../api/api-helper';
import useAuth from '../hooks/auth-hooks';

import { ICardGroupResponse } from '../models/cardgroup.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Get a list of Card Groups
 * 
 * @param {string} [customerId] the customer id - optional
 * @param {string} [partnerId] the partner id - optional
 * 
 * @returns {ICardGroupResponse} the api response | error
 */
const GetCardGroups = async (customerId?: string, partnerId?: string): Promise<ICardGroupResponse> => {
  try {
    apiRetry(awsApiInstance);

    const { userId } = useAuth()!;

    const { data } = await awsApiInstance.get('/card-group', {
      params: {
        'wpId': userId,
        'customerId': customerId,
        'partnerId': partnerId
      }
    });

    return data;
  } catch ( error ) {
    handleRouteError(error, 'Error getting card group data');
    throw(error);
  }
}

export default GetCardGroups; 